import React from 'react';
import AddItem from './AddItem';
import EditItem from './EditItem';
import NiceList from './NiceList';
import ShoppingList from './ShoppingList';
import useGlobal from '../../store';
import AddGiftlist from './AddGiftlist';
import ShareLists from './ShareLists';

const SidePanels = (props) => {

    const [panel] = useGlobal(
        state => state.ui.sidepanel
    );

    return (
        <>
            <EditItem {...panel}></EditItem>
            <AddItem {...panel}></AddItem>
            <NiceList {...panel}></NiceList>
            <ShoppingList {...panel}></ShoppingList>
            <AddGiftlist {...panel}></AddGiftlist>
            <ShareLists {...panel}></ShareLists>
        </>
    );
}

export default SidePanels;